<style lang="scss" scoped="scoped">
// ::-webkit-scrollbar {
// 	width: 0 !important
// }
::-webkit-scrollbar {
  display: none;
}

.vue-grid-item {
  background: #202027;
  // overflow: auto;
  box-sizing: border-box;
  position: relative;
}

.vue-grid-item.vue-grid-placeholder {
  background: #419fff !important;
}

.el-dropdown-link {
  cursor: pointer;
  color: #419fff;
}

.bg {
  background: rgb(18, 18, 18);
}

::v-deep .progress-green {
  .el-progress__text {
    color: #39f16d !important;
  }

  .el-progress-bar__outer {
    background-color: #515c69;
  }
}

::v-deep .el-input__inner {
  color: #419fff;
  border: none;
  background-color: transparent;
  text-align: right;
  width: 260px;
}

::v-deep .el-cascader .el-input .el-icon-arrow-down {
  color: #419fff;
}

::v-deep .el-input__inner::-webkit-input-placeholder {
  color: #419fff;
}

// .vue-grid-layout::-webkit-scrollbar {
// 	width: 0 !important
// }

.module-grid {
  background: #202027;
}
</style>
<style lang="scss">
.el-popper {
  margin-right: 10px;
}
</style>

<template>
  <div style="display: inline;">
    <div ref="container" class="bg" style="position: absolute;height: 100%;width: 100%;box-sizing: border-box;">
      <div ref="header"></div>
      <div v-if="rows">
        <grid-layout v-if="gridContainerHeight != 0" :layout.sync="layout" :col-num="24" :maxRows="24" :row-height="gridRowHeihgt" :is-draggable="false" :is-resizable="false" :is-mirrored="false" :vertical-compact="true" :margin="[0, 0]" :use-css-transforms="true" :style="{ height: gridContainerHeight + 'px' }" style="overflow: auto;">
          <grid-item :refs="'grid_' + item.i" v-for="item in layout" :x="item.x" :y="item.y" :w="item.w" :h="item.h" :i="item.i" :key="item.i">
            <div style="color: white;font-weight: 700;height: 100%;">
              <div v-if="item.i == '1' && rows[0]" style="display: flex;height:100%;align-items: center;justify-content: center;flex-direction: column;">
                <div style="display:flex;align-items: center;">
                  <span style="font-size: 18px;">{{ $t('benyue') }}&nbsp;{{ $t('zongtiliangpinlv') }}</span>
                  <span style="font-size: 22px;color: #39F16D;margin-left: 6px;">{{ rows[0].thisMonthBestProductsProportion }}%</span>
                </div>
                <div style="display:flex;align-items: center;">
                  <span style="font-size: 18px;">{{ $t('huanbi') }}&nbsp;{{ $t('shangyue') }}&nbsp;{{ rows[0].lastMonthBestProductsProportion }}%</span>

                  <img v-if="rows[0].thisMonthBestProductsProportion - rows[0].lastMonthBestProductsProportion >= 0" style="width: 63px;height: 32px;" src="../../../../../../../assets/img/web/quality_analysis/up.svg" />
                  <img v-if="rows[0].thisMonthBestProductsProportion - rows[0].lastMonthBestProductsProportion < 0" style="width: 63px;height: 32px;" src="../../../../../../../assets/img/web/quality_analysis/down.svg" />
                  <span v-if="rows[0].thisMonthBestProductsProportion - rows[0].lastMonthBestProductsProportion >= 0" style="font-size: 22px;color: #39F16D;margin-left: 6px;">{{ (rows[0].thisMonthBestProductsProportion - rows[0].lastMonthBestProductsProportion).toFixed(2) }}%</span>
                  <span v-if="rows[0].thisMonthBestProductsProportion - rows[0].lastMonthBestProductsProportion < 0" style="font-size: 22px;color: #FF3A5E;margin-left: 6px;">{{ (rows[0].lastMonthBestProductsProportion - rows[0].thisMonthBestProductsProportion).toFixed(2) }}%</span>
                </div>
              </div>
              <div v-if="item.i == '2'" style="display: flex;height:100%;align-items: center;justify-content: center;flex-direction: column;">
                <div style="display:flex;align-items: center;">
                  <span style="font-size: 18px;">{{ $t('benyue') }}&nbsp;{{ $t('shebei') }}&nbsp;</span>
                  <span style="font-size: 18px;color: #FF3A5E;">{{ rows[0].thisMonthEquipmentProductsProportion && rows[0].thisMonthEquipmentProductsProportion.name }}&nbsp;</span>
                  <span style="font-size: 18px;">{{ $t('liangpinlv') }}</span>
                  <span style="font-size: 18px;color: #FF3A5E;">{{ $t('zuidi') }}&nbsp;</span>
                  <span style="font-size: 22px;color: #FF3A5E;margin-left: 6px;">{{ rows[0].thisMonthEquipmentProductsProportion && rows[0].thisMonthEquipmentProductsProportion.thismonthequipmentproductsproportion }}%</span>
                </div>
                <div style="display:flex;align-items: center;">
                  <span style="font-size: 18px;">{{ $t('shangyue') }}&nbsp;{{ $t('shebei') }}&nbsp;</span>
                  <span style="font-size: 18px;color: #FF3A5E;">{{ rows[0].lastMonthEquipmentProductsProportion && rows[0].lastMonthEquipmentProductsProportion.name }}&nbsp;</span>
                  <span style="font-size: 18px;">{{ $t('liangpinlv') }}</span>
                  <span style="font-size: 18px;color: #FF3A5E;">{{ $t('zuidi') }}&nbsp;</span>
                  <span style="font-size: 22px;color: #FF3A5E;margin-left: 6px;">{{ rows[0].lastMonthEquipmentProductsProportion && rows[0].lastMonthEquipmentProductsProportion.lastmonthequipmentproductsproportion }}%</span>
                </div>
              </div>
              <div v-if="item.i == '3'" style="display: flex;height:100%;align-items: center;justify-content: center;flex-direction: column;">
                <div style="display:flex;align-items: center;">
                  <span style="font-size: 18px;">{{ $t('benyue') }}&nbsp;{{ $t('buliangyuanyin') }}&nbsp;</span>
                  <span style="font-size: 18px;color: #FF3A5E;">{{ rows[0].thisMonthDefectCodeQuantity && rows[0].thisMonthDefectCodeQuantity.desc }}&nbsp;</span>
                  <span style="font-size: 18px;">{{ $t('zhanbi') }}</span>
                  <span style="font-size: 18px;color: #FF3A5E;">{{ $t('zuigao') }}&nbsp;</span>
                  <span style="font-size: 22px;color: #FF3A5E;margin-left: 6px;">{{ rows[0].thisMonthDefectCodeQuantity && rows[0].thisMonthDefectCodeQuantity.thismonthmaxdefectquantity }}%</span>
                </div>
                <div style="display:flex;align-items: center;">
                  <span style="font-size: 18px;">{{ $t('shangyue') }}&nbsp;{{ $t('buliangyuanyin') }}&nbsp;</span>
                  <span style="font-size: 18px;color: #FF3A5E;">{{ rows[0].lastMonthDefectCodeQuantity && rows[0].lastMonthDefectCodeQuantity.desc }}&nbsp;</span>
                  <span style="font-size: 18px;">{{ $t('zhanbi') }}</span>
                  <span style="font-size: 18px;color: #FF3A5E;">{{ $t('zuigao') }}&nbsp;</span>
                  <span style="font-size: 22px;color: #FF3A5E;margin-left: 6px;">{{ rows[0].lastMonthDefectCodeQuantity && rows[0].lastMonthDefectCodeQuantity.thismonthmaxdefectquantity }}%</span>
                </div>
              </div>
              <div v-if="item.i == '4'" style="display: flex;height:100%;align-items: center;justify-content: center;flex-direction: column;">
                <div style="display:flex;align-items: center;">
                  <span style="font-size: 18px;">{{ $t('benyue') }}&nbsp;{{ $t('') }}&nbsp;</span>
                  <span style="font-size: 18px;color: #FF3A5E;">{{ rows[0].thisMonthProductProportion && rows[0].thisMonthProductProportion.productcodeandname }}&nbsp;</span>
                  <span style="font-size: 18px;">{{ $t('liangpinlv') }}</span>
                  <span style="font-size: 18px;color: #FF3A5E;">{{ $t('zuidi') }}&nbsp;</span>
                  <span style="font-size: 22px;color: #FF3A5E;margin-left: 6px;">{{ rows[0].thisMonthProductProportion && rows[0].thisMonthProductProportion.productionyield }}%</span>
                </div>
                <div style="display:flex;align-items: center;">
                  <span style="font-size: 18px;">{{ $t('shangyue') }}&nbsp;{{ $t('') }}&nbsp;</span>
                  <span style="font-size: 18px;color: #FF3A5E;">{{ rows[0].lastMonthProductProportion && rows[0].lastMonthProductProportion.productcodeandname }}&nbsp;</span>
                  <span style="font-size: 18px;">{{ $t('liangpinlv') }}</span>
                  <span style="font-size: 18px;color: #FF3A5E;">{{ $t('zuidi') }}&nbsp;</span>
                  <span style="font-size: 22px;color: #FF3A5E;margin-left: 6px;">{{ rows[0].lastMonthProductProportion && rows[0].lastMonthProductProportion.productionyield }}%</span>
                </div>
              </div>
              <template v-for="(row, j) in rows">
                <div v-if="j > 0 && j + 4 == parseInt(item.i)" style="width: 100%;height: 100%;padding:20px;padding-top:10px;display: flex;flex-direction: column;">
                  <div style="color: white;font-size: 18px;font-weight: 700;flex-shrink: 0;">
                    {{ [$t('zuorizhibiao'), $t('benyuezhibiao'), $t('shangyuezhibiao')][j - 1] }}
                  </div>
                  <div style="display: flex;flex: 1;margin-top: 10px;">
                    <div style="flex: 1;flex-direction: column;display: flex;">
                      <div class="titleBar" style="display: flex;align-items:center ;flex-shrink: 0;">
                        <span style="width: 4px;height: 13px;background: #39F16D;margin-right:12px ;"></span>
                        <p style="font-size: 16px;color: #FFFFFF;font-weight: 700;">
                          {{ [$t('zuorishebeiliangpinlv'), $t('benyueshebeiliangpinlv'), $t('shangyueshebeiliangpinlv')][j - 1] }}
                        </p>
                      </div>
                      <div style="flex: 1;display: flex;flex-direction: column;justify-content: space-between;width: 100%;margin-top: 16px;">
                        <div style="display: flex;width: 100%;" v-for="k in 5">
                          <template v-if="row.equipmentBestProductProportion[k - 1]">
                            <div style="color: white;width: 60px;">
                              {{ row.equipmentBestProductProportion[k - 1].equipmentName }}
                            </div>
                            <div style="flex: 1;">
                              <el-progress class="progress-green" :color="'#39F16D'" :percentage="row.equipmentBestProductProportion[k - 1].proportion"> </el-progress>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                    <div style="flex: 1;margin-left: 100px;display: flex;flex-direction: column;">
                      <div class="titleBar" style="display: flex;align-items:center ;flex-shrink: 0;">
                        <span style="width: 4px;height: 13px;background: #FFC83A;margin-right:12px ;"></span>
                        <p style="font-size: 16px;color: #FFFFFF;font-weight: 700;">
                          {{ [$t('zuoribuliangyuanyinfenbu'), $t('benyuebuliangyuanyinfenbu'), $t('shangyuebuliangyuanyinfenbu')][j - 1] }}
                        </p>
                      </div>
                      <div ref="chart" style="flex: 1;width: 100%;margin-top: 16px;">
                        <div style="width: 100%;overflow: hidden;" :style="{ height: chartHeight + 'px' }" :id="'YongxinMonitorQualityAnalysisChart1' + (j - 1)"></div>
                      </div>
                    </div>
                    <div style="flex: 1;margin-left: 100px;">
                      <div class="titleBar" style="display: flex;align-items:center ;">
                        <span style="width: 4px;height: 13px;background: #419FFF;margin-right:12px ;"></span>
                        <p style="font-size: 16px;color: #FFFFFF;font-weight: 700;">
                          {{ [$t('zuorichanpinliangpinlv'), $t('benyuechanpinliangpinlv'), $t('shangyuechanpinliangpinlv')][j - 1] }}
                        </p>
                      </div>
                      <div style="flex: 1;width: 100%;margin-top: 16px;">
                        <div style="width: 100%;overflow: hidden;" :style="{ height: chartHeight + 'px' }" :id="'YongxinMonitorQualityAnalysisChart2' + (j - 1)"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </grid-item>
        </grid-layout>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import VueGridLayout from 'vue-grid-layout';

export default {
  name: 'web_customize_yongxin_monitor_mes_quality_analysis_index',
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem
  },

  data() {
    return {
      rows: null,
      charts1: [],
      charts2: [],
      timer: null,
      chartData: [
        {
          name: '圣彼得堡来客',
          value: 56
        },
        {
          name: '陀思妥耶夫斯基全集',
          value: 1
        },
        {
          name: '史记精注全译（全6册）',
          value: 8
        },
        {
          name: '加德纳艺术通史',
          value: 5
        },
        {
          name: '表象与本质',
          value: 5
        },
        {
          name: '其它',
          value: 38
        }
      ],
      chartHeight: 0,
      chartWidth: 0,
      orgId: this.store.state.organizations[0].id,
      gridContainerHeight: 0,
      gridRowHeihgt: 0,
      layout: [
        {
          x: 0,
          y: 0,
          w: 5,
          h: 3.5, //应该是6
          i: '1'
        },
        {
          x: 5,
          y: 0,
          w: 5,
          h: 3.5, //应该是6
          i: '2'
        },
        {
          x: 10,
          y: 0,
          w: 6,
          h: 3.5, //应该是6
          i: '3'
        },
        {
          x: 16,
          y: 0,
          w: 8,
          h: 3.5, //应该是6
          i: '4'
        },

        {
          x: 0,
          y: 3.5,
          w: 24,
          h: 6.83,
          i: '5'
        },
        {
          x: 0,
          y: 10.33,
          w: 24,
          h: 6.83,
          i: '6'
        },
        {
          x: 0,
          y: 17.16,
          w: 24,
          h: 6.83,
          i: '7'
        }
      ]
    };
  },
  watch: {
    orgId(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.getQuality();
    }
  },

  created() {
    this.utils.event_hub.$emit('TOGGLE_TABBAR', true);
    this.timer = setInterval(() => {
      this.getQuality();
    }, 120000);
    this.getQuality();
  },
  activated() {
    this.resize();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    getQuality() {
      console.log(this.orgId);
      this.http
        .get('/web/report/page/quality_analysis', {
          params: {
            orgId: this.orgId
          }
        })
        .then(response => {
          this.rows = response.data.rows;
          setTimeout(() => {
            for (var i = 0; i < 3; i++) {
              if (!this.charts1[i]) {
                this.initChart1(i);
              }
              let defectCodeDistribution = this.rows[i + 1].defectCodeDistribution;
              for (var j = 0; j < defectCodeDistribution.length; j++) {
                defectCodeDistribution[j].name = defectCodeDistribution[j].name + '||' + defectCodeDistribution[j].id;
              }

              this.charts1[i].setOption({
                series: [
                  {
                    data: defectCodeDistribution
                  }
                ]
              });
              if (!this.charts2[i]) {
                this.initChart2(i);
              }
              let bestProductProportion = this.rows[i + 1].bestProductProportion;

              let names = bestProductProportion.map(item => {
                return item.productCodeAndName;
              });
              let values = bestProductProportion.map(item => {
                return item.proportion;
              });
              this.charts2[i].setOption({
                xAxis: {
                  data: names
                },
                series: [
                  {
                    data: values
                  }
                ]
              });
            }
          }, 500);
        });
    },

    initChart1(index) {
      var chartDom = document.getElementById('YongxinMonitorQualityAnalysisChart1' + index);
      this.charts1[index] = this.echarts.init(chartDom);
      let chart = this.charts1[index];
      let option = {
        tooltip: {
          trigger: 'item',
          formatter: params => {
            return this.$t(params.data.name.split('||')[0]) + ':' + params.data.value + '%';
          }
        },
        legend: {
          top: 'center',
          left: 'right',
          width: '70%',
          icon: 'circle',
          itemWidth: 8, // 设置宽度
          itemHeight: 8, // 设置高度
          textStyle: {
            //图例的样式
            color: 'white'
          },
          formatter: name => {
            return this.$t(name.split('||')[0]);
          }
        },
        series: [
          {
            radius: ['0%', '92%'],
            center: ['16%', '50%'],
            type: 'pie',
            left: 'center',
            width: '100%',

            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            itemStyle: {
              // 间隔

              normal: {
                color: function(colors) {
                  var colorList = ['#FBFF41', '#FFD541', '#FFB03A', '#FF8541', '#FF6341', '#FF4141'];
                  return colorList[colors.dataIndex];
                }
              }
            }
          }
        ]
      };

      option && this.charts1[index].setOption(option);
    },

    initChart2(index) {
      var chartDom = document.getElementById('YongxinMonitorQualityAnalysisChart2' + index);
      this.charts2[index] = this.echarts.init(chartDom);
      let option = {
        backgroundColor: null,
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '0',
          right: '0',
          bottom: '0',
          top: '10',
          containLabel: true
        },

        xAxis: {
          show: true,
          type: 'category',

          axisLabel: {
            width: 100,
            overflow: 'breakAll',
            textStyle: {
              fontSize: 12,
              color: '#C0C4CC'
            },
            interval: 0
          },
          axisTick: {
            show: false
          },
          data: []
        },
        yAxis: [
          {
            show: true,
            type: 'value',
            min: 0,

            axisTick: {
              show: false
            },
            axisLabel: {
              textStyle: {
                fontSize: 12,
                color: '#C0C4CC'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: '#606672'
              }
            }
          }
        ],
        series: [
          {
            name: this.$t('liangpinlv'),
            type: 'bar',
            barWidth: '8px',
            itemStyle: {
              normal: {
                color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#6FE5FF'
                  },
                  {
                    offset: 1,
                    color: '#1C70C6'
                  }
                ]),
                barBorderRadius: 4
              }
            },
            data: []
          }
        ]
      };
      option && this.charts2[index].setOption(option);
    },

    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.header) {
          return;
        }
        this.gridContainerHeight = this.$refs.container.offsetHeight;
        this.gridRowHeihgt = this.gridContainerHeight / 24;
        this.chartHeight = this.$refs.chart[0].offsetHeight;
        this.chartWidth = this.$refs.chart[0].offsetWidth;

        for (var i = 0; i < 3; i++) {
          if (this.charts1[i]) {
            this.charts1[i].getDom().style.height = '0px';
            this.charts1[i].resize();
          }
          if (this.charts2[i]) {
            this.charts2[i].getDom().style.height = '0px';
            this.charts2[i].resize();
          }
        }
        setTimeout(() => {
          this.chartHeight = this.$refs.chart[0].offsetHeight;
          this.chartWidth = this.$refs.chart[0].offsetWidth;
          setTimeout(() => {
            for (var i = 0; i < 3; i++) {
              if (this.charts1[i]) {
                this.charts1[i].getDom().style.height = this.chartHeight + 'px';
                this.charts1[i].resize();
              }
              if (this.charts2[i]) {
                this.charts2[i].getDom().style.height = this.chartHeight + 'px';
                this.charts2[i].resize();
              }
            }
          }, 100);
        }, 200);
      }, 500);
    }
  }
};
</script>
